export default __webpack_public_path__ + "static/media/nft-6@2x.e4114776.png";